import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FroalaViewModule } from 'angular-froala-wysiwyg';
import { ngfModule } from 'angular-file';

import { TextViewerModule } from '../text-viewer/index';
import { TextEditorModule } from '../text-editor/index';
import { LetterWriteProfileModule } from '../letter-write-profile/index';
import { LetterWriteFileListModule } from '../letter-write-file-list/index';
import { LetterSimplifiedTargetTextModule } from '../letter-simplified-target-text/index';

import { ByteLengthModule } from '@schoolbelle/shared/directives';

import { LetterWriteAbstractComponent } from './letter-write.component';
import { AbstractLetterWriteResolve } from './letter-write.resolve';

import { TranslationDropdownModule } from '../translation-dropdown/index';
import { TranslationEditorModule } from '../translation-editor/index';

@NgModule({
  declarations: [LetterWriteAbstractComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    LetterWriteProfileModule,
    LetterSimplifiedTargetTextModule,
    TextEditorModule, TextViewerModule,
    FroalaViewModule.forRoot(),
    ngfModule,
    LetterWriteFileListModule,
    RouterModule,
    ByteLengthModule,

    TranslationDropdownModule, TranslationEditorModule,

  ],
  exports:[
    CommonModule,
    FormsModule, ReactiveFormsModule,
    LetterWriteProfileModule,
    LetterSimplifiedTargetTextModule,
    TextEditorModule, TextViewerModule,
    FroalaViewModule,
    ngfModule,
    LetterWriteFileListModule,
    RouterModule,
    TranslationDropdownModule, TranslationEditorModule,

  ],
  providers:[AbstractLetterWriteResolve],
})
export class LetterWriteAbstractModule { }
